import { Result } from 'antd'
import { Icon } from '@iconify/react'

import './index.css'

const SuccessFormPage = ({ currentData }) => {
    return (
        <Result
            status="success"
            icon={
                <div
                    style={{
                        width: 72,
                        height: 72,
                        borderRadius: 18,
                        background:
                            'linear-gradient(135deg, #4f46e5 0%, #6366f1 60%, #818cf8 100%)',
                        boxShadow: '0 12px 28px rgba(79, 70, 229, 0.18)',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                    }}
                >
                    <Icon icon="mdi:check-bold" width={34} height={34} />
                </div>
            }
            rootClassName="public-page-success"
            title="Thank you!"
            subTitle={
                <>
                    <h5>Your application has been submitted successfully.</h5>
                    <h6>
                        A copy of your application will be sent to{' '}
                        <b>{currentData?.personalEmail}</b> for your records.
                    </h6>
                </>
            }
            style={{
                width: '100%',
            }}
        />
    )
}

export default SuccessFormPage
